
import { defineComponent, PropType } from 'vue'

export enum AdminNoticeTypes {
  addMoreSeats,
  upgradePlan,
  enterprise,
  oneAdmin
}

export default defineComponent({
  name: 'AdminNotices',
  props: {
    type: {
      type: [Number, String] as PropType<AdminNoticeTypes>,
      required: true
    }
  },
  data() {
    return {
      noticeMeta: {
        [AdminNoticeTypes.addMoreSeats]: {
          icon: 'solid-alert-circle',
          type: 'info',
          copy: 'All member seats are occupied. Please add more seats to invite new members to your team.',
          copyColor: 'text-robin-300',
          dismissible: false
        },
        [AdminNoticeTypes.upgradePlan]: {
          icon: 'solid-alert-circle',
          type: 'info',
          copy: 'You have reached the member seats limit for your plan. Please upgrade to get more seats.',
          copyColor: 'text-robin-300',
          dismissible: false,
          cta: {
            icon: 'zap',
            copy: 'Upgrade plan',
            to: this.$generateRoute(['settings', 'billing'], false, true)
          }
        },
        [AdminNoticeTypes.enterprise]: {
          icon: 'solid-alert-circle',
          type: 'info',
          copy: 'You have reached the seat limit for your plan. Please reach out to us to explore your options for an upgrade.',
          copyColor: 'text-robin-300',
          dismissible: false,
          cta: {
            icon: 'mail',
            copy: 'Contact sales',
            to: 'mailto:sales@deepsource.io'
          }
        },
        [AdminNoticeTypes.oneAdmin]: {
          icon: 'solid-alert-circle',
          iconColor: 'text-honey-500',
          type: 'warning',
          copy: 'You are currently the only administrator of this team. We recommend adding at least one more administrator to improve the bus factor.',
          dismissible: true,
          handlers: {
            dismiss: () => {
              this.$emit('dismiss', AdminNoticeTypes.oneAdmin)
            }
          }
        }
      } as Record<
        AdminNoticeTypes,
        {
          icon: string
          iconColor?: string
          type: string
          copy: string
          copyColor: string
          dismissible: boolean
          cta?: {
            icon: string
            copy: string
            to: string
          }
          handlers?: {
            dismiss: () => void
          }
        }
      >
    }
  },
  computed: {
    buttonIcon(): string {
      return this.noticeMeta[this.type].cta?.icon || ''
    },
    buttonCopy(): string {
      return this.noticeMeta[this.type].cta?.copy || ''
    },
    buttonLink(): string {
      return this.noticeMeta[this.type].cta?.to || ''
    }
  }
})
